import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'sm-backend-recovery-banner',
  templateUrl: './sm-backend-recovery-banner.component.html',
  styleUrls: ['./sm-backend-recovery-banner.component.scss'],
  standalone: false,
})
export class SmBackendRecoveryBannerComponent {
  @Input() title = '';
  @Input() description = '';
  @Input() countdownText = '';
  @Input() countdownSeconds = 0;
  @Input() retryDelaySeconds = 0;
  @Input() progressAriaLabel = '';
  @Input() retryLabel = '';
  @Input() checking = false;
  @Output() retryRequested = new EventEmitter<void>();

  get progressValue(): number {
    if (this.retryDelaySeconds <= 0) {
      return 0;
    }

    return Math.max(0, Math.min(1, this.countdownSeconds / this.retryDelaySeconds));
  }
}
